import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-duigou",
  "use": "icon-duigou-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-duigou\">\r\n    <path d=\"M328.021333 816.682667a40.106667 40.106667 0 0 1-34.688-20.181334L133.973333 517.802667a39.978667 39.978667 0 1 1 69.504-39.68L336.64 711.253333 827.733333 218.794667a40.106667 40.106667 0 0 1 56.618667-0.085334 40.106667 40.106667 0 0 1 0.085333 56.576L358.186667 803.072l-1.877334 1.92a39.978667 39.978667 0 0 1-28.330666 11.690667z\" p-id=\"5524\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol